import { render, staticRenderFns } from "./ArticleProductCart.vue?vue&type=template&id=a01f486e"
import script from "./ArticleProductCart.vue?vue&type=script&lang=js"
export * from "./ArticleProductCart.vue?vue&type=script&lang=js"
import style0 from "./ArticleProductCart.vue?vue&type=style&index=0&id=a01f486e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports